import React, { ChangeEvent, useState } from 'react';
import styles from './SelectAllStudies.module.scss';
import {
  Checkbox,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from 'components/core';

type Props = {
  handleStudySelection: (event: ChangeEvent<HTMLInputElement>) => void;
  isSelected: boolean;
  renderDSCheckbox?: boolean;
  dataTrackKey?: string;
};

const SelectAllStudies = ({
  handleStudySelection,
  isSelected,
  renderDSCheckbox,
  dataTrackKey,
}: Props) => {
  const [isChecked, setIsChecked] = useState(false);
  const labelText = isChecked ? 'Deselect all' : 'Select all';

  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    setIsChecked(event.currentTarget.checked);
    handleStudySelection(event);
  };

  return (
    <Tooltip placement="bottom">
      <TooltipTrigger>
        {renderDSCheckbox ? (
          // Tooltip not appearing when checkbox is child due to
          // how refs are passed around in trigger and checkbox
          <div>
            <Checkbox
              size="md"
              className="select-all"
              aria-label="Select All"
              checked={isSelected}
              onChange={handleChange}
              data-pendo-key={dataTrackKey}
            >
              All
            </Checkbox>
          </div>
        ) : (
          // Some legacy study lists still use native checkboxes, so on those
          // screens we render a native checkbox in the toolbar to match.
          <div className={styles.SelectAllStudies}>
            <label className="select-all">
              <input
                type="checkbox"
                className={`${styles.checkbox}`}
                aria-label="Select All"
                checked={isSelected}
                onChange={handleChange}
                data-pendo-key={dataTrackKey}
              ></input>
              <span>All</span>
            </label>
          </div>
        )}
      </TooltipTrigger>
      <TooltipContent>{labelText}</TooltipContent>
    </Tooltip>
  );
};

export default SelectAllStudies;
